import taskManagerApi from '@/features/shared/services/taskManagerApi';
import { ObjectUtil } from '@/features/shared/utils/ObjectUtil';
/**
 * Fetch missions with optional pagination, filters, and an "all" flag.
 */
export async function fetchMissions(page, filters, all = false, limit) {
    try {
        const params = {
            ...(page ? { page } : {}),
            ...(filters || {}),
            ...(all ? { all: true } : {}),
            ...(limit ? { limit } : {}),
        };
        const response = await taskManagerApi.get('/mission', { params });
        return response.data.data;
    }
    catch (error) {
        // Safely narrow the error
        if (error instanceof Error) {
            const serverError = error?.response?.data?.error;
            throw new Error(serverError?.details ?? serverError?.message ?? error.message);
        }
        else {
            throw new Error("Erreur inconnue lors de la récupération des missions");
        }
    }
}
/**
 * Create a new mission.
 */
export async function addMission(mission) {
    try {
        const response = await taskManagerApi.post("/mission", mission);
        // logger?.info(`Mission "${mission.label}" created successfully.`, { mission });
        return response.data;
    }
    catch (error) {
        if (error instanceof Error) {
            const serverError = error?.response?.data?.error;
            throw new Error(serverError?.details ?? serverError?.message ?? error.message);
        }
        else {
            throw new Error("Erreur inconnue lors de la création de la mission");
        }
    }
}
/**
 * Update an existing mission.
 */
export async function updateMission(mission) {
    try {
        const updatedMission = ObjectUtil.omitField(mission, 'id');
        const response = await taskManagerApi.put(`/mission/${mission.id}`, updatedMission);
        // logger?.info(`Mission "${mission.label}" updated successfully.`, { mission });
        return response.data;
    }
    catch (error) {
        if (error instanceof Error) {
            const serverError = error?.response?.data?.error;
            throw new Error(serverError?.details ?? serverError?.message ?? error.message);
        }
        else {
            throw new Error("Erreur inconnue lors de la modification de la mission");
        }
    }
}
/**
 * Delete a mission by its ID.
 */
export async function deleteMission(id) {
    try {
        const response = await taskManagerApi.delete(`/mission/${id}`);
        // logger?.info(`Mission "${id}" deleted successfully.`);
        return response.data;
    }
    catch (error) {
        if (error instanceof Error) {
            const serverError = error?.response?.data?.error;
            throw new Error(serverError?.details ?? serverError?.message ?? error.message);
        }
        else {
            throw new Error("Erreur inconnue lors de la suppression de la mission");
        }
    }
}
export async function fetchTaskMissions(taskId) {
    const response = await taskManagerApi.get(`/task/${taskId}/missions`);
    return response.data.data.taskMissions;
}
